export default "__VITE_ASSET__Brn$4Qi6__"